import { Box, Stack, Typography } from '@mui/material';
import { FC } from 'react';

interface PinCodeGuessProps {
  values: string[];
}

const PinCodeGuess: FC<PinCodeGuessProps> = ({ values }) => {
  return (
    <Stack
      direction="row"
      display="flex"
      justifyContent="space-between"
      sx={(theme) => ({ width: '100%' })}
    >
      {values.map((value, index) => (
        <NumberItem key={index} value={value} />
      ))}
    </Stack>
  );
};

type NumberItemProps = {
  value: string;
};

const NumberItem: FC<NumberItemProps> = ({ value }) => {
  return (
    <Box
      sx={(theme) => ({
        width: 63,
        height: 63,
        borderRadius: 4,
        // boxShadow: `${theme.palette.boxBorder?.main} 2px 2px 3px 1px`,
        border: `2px solid ${theme.palette.card?.main}`,
      })}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant="h4">{value}</Typography>
    </Box>
  );
};

export default PinCodeGuess;
